export default {
  showAuthBtn: true,
  showAuthDialog: false,
  panoramaHeader: false
}
